<template>
    <div class="customtrips">
        <home-nav></home-nav>
        <img class="customtrips-back" src="@/assets/images/customtrips/dingzhi_bg.png" alt="">
        <div class="customtrips-box">
            <div class="customtrips-box-top">
                <img src="@/assets/images/customtrips/dingzhi_img_title.png" alt="">
            </div>
            <div class="customtrips-box-title">
                累计已为 865,536,1人次 报价，服务对比，选择包车最优解
            </div>

            <el-form class="customtrips-box-form" ref="form" :model="form" label-width="80px">
                <p class="customtrips-box-form-title">
                    - 在线预约专属行程报价 -
                </p>

                <el-form-item label="出发地点">
                    <el-col :span="23">
                        <el-cascader
                                style="width: 100%;"
                                placeholder="出发城市"
                                :options="options"
                                filterable
                                v-model="form.startCity"
                                @change="startcityChange"
                        >
                        </el-cascader>
                    </el-col>
                </el-form-item>

                <el-form-item label="*手机号码">
                    <el-col :span="23">
                        <el-input oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                  v-model="form.telephone"
                                  placeholder="请输入您的手机号码，报价结果将发送至您的手机号"
                                  maxlength="11"
                        >

                        </el-input>
                    </el-col>
                </el-form-item>

                <p class="customtrips-box-form-title">
                    - 发给以下车队获取报价 -
                </p>

                <div class="customtrips-select-all-list">
                    <el-checkbox-group class="customtrips-select-column" v-model="checkedCities"
                                       @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="(city,index) in teamList" :label="city" :key="index">{{city.company_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>

                <div class="bottom-btn" @click="onSubmitThreeTeam()">
                    免费获取车队报价
                </div>

                <div class="protect">
                    * 预约后会有专门的司机联系沟通您的需求
                </div>
            </el-form>
        </div>
        <home-footer></home-footer>

        <div class="rightTel">
            <div class="rightTelBox" id="serve-img-area" @click="showTelephone()" @mouseenter="enter()" @mouseleave="leave()">
                <div class="rightTelBoxIn point-area">
                    <img v-show="hoverIcon" src="@/assets/images/customtrips/icon_phone01.png" alt="">
                    <div v-show="!hoverIcon" class="rightTelText">
                        获取<br>
                        号码
                    </div>
                    <div class="point point-10"></div>
                    <div class="point point-40"></div>
                    <div class="point point-shadow point-80"></div>
                </div>
                <div class="rightTelBoxOut" v-show="telShow">
                    <p class="rightTelBoxOutTop">
                        该城市调度员手机号：
                    </p>
                    <p class="rightTelBoxOutTel">
                        {{ xuniTelephone }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeNav from '@/components/homeNav';
    import HomeFooter from '@/components/homeFooter';
    import {mapGetters} from 'vuex';

    const cityOptions = ['嘻嘻出行车队', '皇包车（厦门）科技集团有限公司', '途时光车队'];
    export default {
        name: "customTrips",
        components: {
            HomeNav,
            HomeFooter
        },
        data() {
            return {
                options: [],
                form: {
                    startCity: [], //出发城市
                    telephone: '', //手机号码
                },
                checkedCities: [],
                cities: [],
                cityId: '',
                teamList: [],
                team_id_list: "",
                cityinfo_id_list: "",

                hoverIcon: true,
                telShow: false,
                xuniTelephone: '',
                timer: null,
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            var cityid = this.$store.state.cityId;
            // var cityname = this.$store.state.cityName;
            this.getCityDataCus();
            this.getThreeTeam(cityid);
            /*if(this.timer){
                console.log('1')
            } else {
                console.log('2')
            }*/
            this.getUrl();
        },
        computed:{
          ...mapGetters(['getuserIp'])
        },
        methods: {
            getUrl(){
                var now_url = localStorage.getItem('now_url');
                if(now_url == '' || now_url == null || now_url == undefined){
                    var url = window.location.href;
                    localStorage.setItem('now_url', url);
                }
            },
            getCityDataCus() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },

            startcityChange() {
                var that = this;
                that.team_id_list = '';
                that.cityinfo_id_list = '';
                that.checkedCities = [];
                //切换城市之后显示的
                that.$axios.post('/cityNameGetId', {
                    city_name: that.form.startCity[1],
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.cityId = res.data;
                        that.getThreeTeam(that.cityId); //切换城市获取三个车队
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },

            getThreeTeam(id) {
                var that = this;
                if (id != '') {
                    that.$axios.post('/CustomizedItineraryTeam', {
                        city_id: id
                    }).then((res) => {
                        res = res.data;
                        if (res.status == 200) {
                            that.teamList = res.data;
                            that.checkedCities = res.data;
                        } else {
                            // layer.msg('数据获取失败，请刷新！', {icon: 2});
                            this.$message('数据获取失败，请刷新！');
                        }
                    }).catch((error) => {
                        // console.log(error);
                    });
                } else {
                    // layer.msg('请选择城市！');
                    this.$message('请选择城市！');
                }
            },

            // 多选框切换事件
            handleCheckedCitiesChange(value) {
                var that = this;
            },

            onSubmitThreeTeam() {
                var that = this;
                var currentSelectTeamLen = that.checkedCities.length;
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                that.team_id_list = '';
                that.cityinfo_id_list = '';

                if (that.form.startCity == undefined || that.form.startCity.length <= 0) {
                    // layer.msg('出发城市不能为空~', {icon: 2});
                    this.$message('出发城市不能为空~');
                    return;
                }
                if (that.form.telephone == undefined || that.form.telephone.length <= 0) {
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }

                if (!myreg.test(that.form.telephone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }

                if (currentSelectTeamLen < 1) {
                    /*layer.msg('请至少选择发送给一个车队！', {
                        icon: 2
                    });*/
                    this.$message('请至少选择发送给一个车队！');
                    return;
                }

                that.checkedCities.forEach((item) => {
                    that.team_id_list = that.team_id_list + item.team_id + ",";
                    that.cityinfo_id_list = that.cityinfo_id_list + item.city_info_id + ",";
                })
                that.team_id_list = that.team_id_list.substr(0, that.team_id_list.length - 1);
                that.cityinfo_id_list = that.cityinfo_id_list.substr(0, that.cityinfo_id_list.length - 1);

                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                // console.log(that.form.startCity[1]);
                // console.log(that.form.telephone);
                // console.log(that.team_id_list);
                // console.log(that.cityinfo_id_list);
                // console.log(that.checkedCities);

                that.$axios.post('/CustomizedItinerary', {
                    start_city: that.form.startCity[1],
                    source: "PC",
                    mobile: that.form.telephone,
                    team_id: that.team_id_list,
                    city_info_id: that.cityinfo_id_list
                }).then((res) => {
                    // layer.closeAll();
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg('您的行程信息发送成功，请耐心等待回电！', {icon: 1});
                        this.$message('您的行程信息发送成功，请耐心等待回电！');
                        that.form.startCity = [];
                        that.form.telephone = '';
                    } else {
                        // layer.closeAll();
                        // layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },

            showTelephone(){
                var team;
                var mobile;
                var start_city = this.form.startCity[1] ? this.form.startCity[1] : this.$store.state.cityName;
                this.$axios.post('https://api.hbc1223.com/api/averageDistributionMobile',{
                    start_city: start_city
                }).then((res)=>{
                    // layer.closeAll();
                    res = res.data;
                    if(res.status == 200){
                        team = res.data.team;
                        mobile = res.data.mobile;
                        this.bindTel(team,mobile);
                    } else {
                        console.log(res.data);
                    }
                }).catch((error)=>{
                    // layer.closeAll();
                });
            },

            bindTel(team,mobile){
                var start_city = this.form.startCity[1] ? this.form.startCity[1] : this.$store.state.cityName;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                this.$axios.post('https://api.hbc1223.com/api/BindFictitious',{
                    city: start_city,
                    referrer: '',
                    url: url,
                    info_id: userIp,
                    from: 14,
                    team: team,
                    phone: mobile,
                    source: '发送三家车队页'
                }).then((res)=>{
                    res = res.data;
                    if(res.status == 200){
                        // console.log(res.data);
                        this.xuniTelephone = res.data;
                        this.telShow = true;
                        var timeClose = 180;
                        this.timer = setInterval(()=> {
                            timeClose = timeClose-1;
                            // console.log(timeClose);
                            if(timeClose == 0){
                                this.telShow = false;
                                clearInterval(this.timer);
                            }
                        },1000);
                    } else {
                        console.log(res);
                    }
                }).catch((error)=>{
                    console.log(error);
                });
            },
            enter(){
                this.hoverIcon = false;
            },
            leave(){
                this.hoverIcon = true;
            },
        }
    }
</script>

<style scoped>
    @import url('./customTrips.css');
</style>



// WEBPACK FOOTER //
// src/pages/customTrips/customTrips.vue